export const borderSizes = [2, 8, 16, 20, 25, 30];
